export const parecerMedico = [
  { value: true, label: 'Sim' },
  { value: false, label: 'Não' },
];

export const sexo = [
  { value: 1, label: 'Masculino' },
  { value: 3, label: 'Feminino' },
];

export const tipoRequerimento = [
  { value: 1, label: 'Aposentadoria' },
  { value: 2, label: 'Pensão' },
];

export const tipoAposentadoriaRGPS = [
  { value: 1, label: 'Tempo de Contribuição' },
  { value: 2, label: 'Idade' },
  { value: 3, label: 'Invalidez' },
  { value: 4, label: 'Especial' },
  { value: 5, label: 'Tempo de Contribuição Professor' },
  { value: 6, label: 'Compulsória' },
];

export const tipoAposentadoriaRPPS = [
  { value: 1, label: 'Tempo de Contribuição' },
  { value: 2, label: 'Idade' },
  { value: 3, label: 'Invalidez' },
  { value: 4, label: 'Especial' },
  { value: 5, label: 'Tempo de Contribuição Professor' },
  { value: 6, label: 'Compulsória' },
];

export const tipoRegime = [
  { value: 1, label: 'RGPS' },
  { value: 2, label: 'RPPS' },
];

export const tipoEntidade = [
  { value: 1, label: 'Federal' },
  { value: 2, label: 'Municipal' },
  { value: 3, label: 'Estadual' },
];

export const tipoEntidadeControlePagamento = [
  { value: 1, label: 'Federal' },
  { value: 2, label: 'Municipal' },
  { value: 3, label: 'Estadual' },
  { value: '01000', label: 'RGPS' },
];

export const tipoEntidadeControlePagamentoRGPS = [
  { value: 1, label: 'Federal' },
  { value: 2, label: 'Municipal' },
  { value: 3, label: 'Estadual' },
];

export const tipoEntidadeSimulacaoCompensacao = [
  { value: 1, label: 'Federal' },
  { value: 2, label: 'Municipal' },
  { value: 3, label: 'Estadual' },
  { value: '01000', label: 'RGPS' },
];

export const tipoEntidadeDebitosPendentes = [
  { value: 2, label: 'Municipal' },
  { value: 3, label: 'Estadual' },
];

export const visoesSimulacaoCompensacao = [
  { value: 1, label: 'Simulação de Valores a Receber' },
  { value: 2, label: 'Simulação de Valores a Pagar' },
];

export const tipoEntidadeControleDebitosPendentes = [
  { value: 2, label: 'Municipal' },
  { value: 3, label: 'Estadual' },
];

export const estadoCivil = [
  { value: 1, label: 'Solteiro' },
  { value: 2, label: 'Casado' },
  { value: 3, label: 'Viúvo' },
  { value: 4, label: 'Separado judicialmente' },
  { value: 5, label: 'Divorciado' },
];

export const vinculo = [
  { value: 1, label: 'Cônjuge' },
  { value: 2, label: 'Filho' },
  { value: 3, label: 'Pai/mãe' },
  { value: 4, label: 'Irmão' },
  { value: 5, label: 'Designado' },
  { value: 6, label: 'Companheiro' },
  { value: 7, label: 'Ex-cônjuge/companheiro(a)' },
  { value: 8, label: 'Filho adotivo ou menor sob guarda' },
  { value: 9, label: 'Dependente judicial' },
  { value: 10, label: 'Enteado' },
  { value: 11, label: 'Companheiro(a) separado de fato' },
];

export const capacidade = [
  { value: 1, label: 'Válido/capaz' },
  { value: 3, label: 'Inválido/incapaz' },
  { value: 5, label: 'Inválido/capaz' },
  { value: 7, label: 'Válido/incapaz' },
];

export const motivoInclusao = [
  { value: 1, label: 'Filho póstumo' },
  { value: 2, label: 'Decisão judicial' },
];

export const destinatarios = [
  { value: '11000', label: 'Estado de São Paulo' },
  { value: '05045', label: 'Município de Fortaleza' },
  { value: '01000', label: 'RGPS' },
  { value: '17064', label: 'São Paulo' },
  { value: '17018', label: 'Engenheiro P. de Frontin' },
];

export const tiposDocumento = [
  { value: 1, label: 'Certidão de tempo de Contribuição' },
  { value: 2, label: 'Homologação do Tribunal de Contas' },
  { value: 3, label: 'Laudo médico' },
  { value: 4, label: 'Documento identificação' },
  { value: 5, label: 'Documento identificação NIT' },
];

export const tiposEstado = [
  { value: 1, label: 'Criado' },
  { value: 2, label: 'Em exigência' },
  { value: 3, label: 'Alterado' },
  { value: 4, label: 'Aguardando Análise' },
  { value: 5, label: 'Aguardando análise do médico perito' },
  { value: 6, label: 'Em análise' },
  { value: 7, label: 'Em análise pelo médico perito' },
  { value: 8, label: 'Deferido' },
  { value: 9, label: 'Indeferido' },
  { value: 10, label: 'Análise Suspensa' },
  { value: 11, label: 'Em Compensação' },
  { value: 12, label: 'Compensado' },
  { value: 13, label: 'Aguardando compensação da aposentadoria' },
  { value: 14, label: 'Rejeitado' },
  { value: 15, label: 'Exigência/Indeferido' },
  { value: 16, label: 'Indeferido Ratificado' },
  { value: 17, label: 'Criado rejeitado' },
  { value: 18, label: 'Em conflito de período' },
];

export const tiposEstadoParecerMedico = [
  { value: 5, label: 'Aguardando análise do médico perito' },
  { value: 7, label: 'Em análise pelo médico perito' },
];

export const linhasPorPagina = [
  { text: '10', value: 10 },
  { text: '20', value: 20 },
  { text: '30', value: 30 },
];

export const tiposEstadoAnalise = [
  { value: 4, label: 'Aguardando Análise' },
  { value: 6, label: 'Em análise' },
  { value: 10, label: 'Análise Suspensa' },
];

export const resultadoAnalise = [
  { value: 2, label: 'Criar exigência(s)' },
  { value: 8, label: 'Deferir' },
  { value: 9, label: 'Indeferir' },
  { value: 10, label: 'Suspender análise' },
];

export const motivoSuspensao = [
  { value: 1, label: 'Aguardando Processo' },
  { value: 2, label: 'Aguardando Parecer' },
];

export const motivoIndeferimentoAposentadoria = [
  { value: 3, label: 'CTC não atende a portaria 154' },
  { value: 4, label: 'CTC destinada a outro Regime' },
  { value: 5, label: 'CTC emitida por outro Regime' },
  { value: 6, label: 'Tempo de contribuição já utilizado em benefício' },
  { value: 7, label: 'Aposentadoria não passível de compensação' },
  { value: 8, label: 'Doença isenta de carência' },
];

export const exigencia = [
  { value: 1, label: 'Anexar um documento de identificação com CPF' },
  { value: 2, label: 'Alterar a data de nascimento informada no requerimento ou anexar um documento de identificação com a data de nascimento informada' },
  { value: 3, label: 'Alterar o NIT informado no requerimento ou anexar um documento de identificação com o NIT informado' },
  { value: 4, label: 'Alterar sexo informado no requerimento ou anexar um documento de identificação com o sexo informado' },
  { value: 5, label: 'Anexar Certidão de Tempo de Contribuição' },
  { value: 6, label: 'Anexar a Homologação do Tribunal de Contas' },
  { value: 7, label: 'Anexar o Laudo Médico' },
  { value: 8, label: 'Alterar data de início de benefício de pensão' },
  { value: 9, label: 'Alterar renda mensal inicial de pensão' },
  { value: 10, label: 'Incluir dependente' },
  { value: 11, label: 'Excluir dependente' },
  { value: 12, label: 'Alterar CPF do dependente' },
  { value: 13, label: 'Alterar nome da mãe do dependente' },
  { value: 14, label: 'Alterar sexo do dependente' },
  { value: 15, label: 'Alterar estado civil do dependente' },
  { value: 16, label: 'Alterar vínculo do dependente' },
  { value: 17, label: 'Alterar capacidade do dependente' },
  { value: 18, label: 'Alterar tipo de aposentadoria' },
  { value: 19, label: 'Alterar data de início de benefício de aposentadoria' },
  { value: 20, label: 'Alterar tempo de contribuição total em dias' },
  { value: 21, label: 'Alterar tempo de contribuição do regime origem em dias' },
  { value: 22, label: 'Alterar renda mensal inicial de aposentadoria' },
];

export const tipoParticipacao = [
  { value: 1, label: 'Solicitante' },
  { value: 2, label: 'Destinatário' },
];

export const opcaoFiltroPesquisaRelatorio = [
  { value: 1, label: 'Por entidade' },
  { value: 2, label: 'Por visão' },
];

export const opcaoFiltroTipoParticipacao = [
  { value: 1, label: 'Ambos' },
  { value: 2, label: 'Solicitante' },
  { value: 3, label: 'Destinatário' },
];

export const tipoParticipacaoConflitosPeriodos = [
  { value: 2, label: 'Solicitante' },
  { value: 3, label: 'Destinatário' },
];

export const atributoOrdenacao = [
  { value: 'prazo-atendimento-exigencia', label: 'Prazo de atendimento da exigência' },
  { value: 'data-disponibilizacao-analise', label: 'Data de disponibilização pra análise' },
];

export const tipoRequerimentoFilter = [
  { value: null, label: 'Todos' },
  { value: 1, label: 'Aposentadoria' },
  { value: 2, label: 'Pensão' },
];

export const tipoAtendimentoExigencia = [
  { value: 0, label: 'Não atendida' },
  { value: 1, label: 'Atendida' },
  { value: 2, label: 'Rejeitada' },
];

export const beneficioAtivoSimNao = [
  { value: 1, label: 'Sim' },
  { value: 2, label: 'Não' },
];

export const fonteCessacaoAposentadoria = [
  { value: 1, label: 'Cálculo Idade' },
  { value: 2, label: 'RPPS' },
  { value: 3, label: 'SISOB' },
  { value: 4, label: 'SUB' },
  { value: 5, label: 'Ag. Gestora' },
  { value: 7, label: 'SIRC' },
  { value: 6, label: 'Outros' },
];

export const fonteCessacaoPensao = [
  { value: 1, label: 'Cálculo Idade' },
  { value: 2, label: 'RPPS' },
  { value: 4, label: 'SUB' },
  { value: 5, label: 'Ag. Gestora' },
  { value: 6, label: 'Outros' },
];

export const pensaoSemDependentesAtivos = [
  { value: 22, label: 'Pensão sem dependentes ativos' },
];

export const motivosBloqueio = [
  { value: 1, label: 'CND' },
  { value: 2, label: 'Ordem Judicial' },
  { value: 3, label: 'Aluguel' },
  { value: 4, label: 'Contrato Dataprev' },
  { value: 5, label: 'Inadimplência' },
];
export const operacoesGetFilter = [];

export const filaGetFilter = [];

export const operacoesGet = [
  { value: 1, label: 'Criar tarefa Get' },
  { value: 2, label: 'Criar subtarefa GET' },
  { value: 3, label: 'Retornar para pendente' },
  { value: 4, label: 'Cumprir Exigência' },
  { value: 5, label: 'Concluir' },
  { value: 6, label: 'Cancelar sem referência no Comprev' },
  { value: 7, label: 'Cancelar com referência no Comprev' },
];

export const operacoesStatusGet = [
  { value: 1, label: 'Pronta para nova execução' },
  { value: 2, label: 'Concluída' },
  { value: 3, label: 'Falha de negócio' },
  { value: 4, label: 'Indisponibilidade ou falha técnica' },
];

export const operacoesOrigemGet = [
  { value: 1, label: 'Transacional' },
  { value: 2, label: 'Procedure' },
  { value: 3, label: 'Batch' },
];

export const prismaFilter = [
  { value: 1, label: 'CPF' },
  { value: 2, label: 'NIT' },
  { value: 3, label: 'NB' },
];

export const situacaoOrgaoVinculado = [
  { value: 1, label: 'Cadastro Incorreto' },
];

export const tiposAuditoria = [
  { value: 1, label: 'Valor Médio Benefício' },
  { value: 2, label: 'Bloqueio Desbloqueio de Ente Federativo' },
  { value: 3, label: 'Cessação Manual de Requerimento de Aposentadoria' },
  { value: 4, label: 'Cessação Manual de Requerimento de Pensão' },
  { value: 5, label: 'Cessação Manual de Dependente' },
  { value: 6, label: 'Entidade Participante Regime Próprio' },
  { value: 7, label: 'Orgão Vinculado' },
  { value: 9, label: 'Glosa de Dação' },
];

export const regrasDeCalculo = [
  { value: 1, label: 'Integralidade' },
  { value: 2, label: 'Média' },
];

export const convenioComprev = [
  { value: 0, label: 'Não' },
  { value: 1, label: 'Sim' },
];

export const visoesControlePagamento = [
  { value: 1, label: 'Valores a receber' },
  { value: 2, label: 'Valores a pagar' },
];

export const visoesPendenciasRGPS = [
  { value: 1, label: 'Valores a receber' },
];

export const estadosPagamento = [
  { value: 1, label: 'Em Aberto' },
  { value: 2, label: 'Em processamento' },
  { value: 3, label: 'Contestado' },
  { value: 4, label: 'Aguardando análise' },
  { value: 5, label: 'Pago' },
  { value: 6, label: 'Rejeitado' },
  { value: 7, label: 'Não Pago' },
  { value: 8, label: 'Não Monitorado' },
  { value: 9, label: 'Aguardando análise da defesa da regularidade do pagamento' },
  { value: 10, label: 'Aguardando análise da defesa da GRU' },
  { value: 11, label: 'Aguardando análise da defesa extraordinária' },
  { value: 12, label: 'Contestação extraordinária' },
];

export const estadosSimulacaoCompensacao = [
  { value: 1, label: 'Em Aberto' },
  { value: 2, label: 'Em processamento' },
  { value: 3, label: 'Contestado' },
  { value: 4, label: 'Aguardando análise' },
  { value: 5, label: 'Pago' },
  { value: 6, label: 'Rejeitado' },
  { value: 7, label: 'Não Pago' },
  { value: 8, label: 'Não Monitorado' },
];

export const estadosDebitosPendentes = [
  { value: 2, label: 'Em processamento' },
  { value: 5, label: 'Pago' },
  { value: 7, label: 'Não Pago' },
  { value: 9, label: 'Aguardando análise da defesa da regularidade do pagamento' },
  { value: 10, label: 'Aguardando análise da defesa da GRU' },
];

export const estadosPendenciasRGPS = [
  { value: 2, label: 'Em processamento' },
  { value: 7, label: 'Não Pago' },
  { value: 9, label: 'Aguardando análise da defesa da regularidade do pagamento' },
  { value: 10, label: 'Aguardando análise da defesa da GRU' },
];

export const estadosPendenciasRPPSaPagar = [
  { value: 3, label: 'Contestado' },
  { value: 7, label: 'Não Pago' },
  { value: 12, label: 'Contestação extraordinária' },
];

export const estadosPendenciasRPPSaReceber = [
  { value: 4, label: 'Aguardando análise' },
  { value: 11, label: 'Aguardando análise da defesa extraordinária' },
];

export const pendenteEnvio = [
  { value: 0, label: '0' },
  { value: 1, label: '1' },
];

export const tiposMensagem = [
  { value: 1, label: '1 - Nenhum valor recebido' },
  { value: 2, label: '2 - Valor recebido incorreto' },
  { value: 3, label: '3 - Valor pago corretamente dentro do vencimento' },
  { value: 4, label: '4 - Valor pago em atraso ou pago incorretamente' },
  { value: 5, label: '5 - Pagamento rejeitado por divergencia de conta corrente' },
  { value: 6, label: '6 - Pagamento Aprovado' },
  { value: 7, label: '7 - Confirmação do pagamento rejeitado por divergência de contas' },
  { value: 8, label: '8 - Pagamento reprovado em definitivo' },
  { value: 9, label: '9 - Defesa de regularidade do pagamento' },
  { value: 10, label: '10 - Defesa aprovada integralmente / Defesa aprovada com revisão de valor' },
  { value: 11, label: '11 - Defesa reprovada' },
  { value: 12, label: '12 - Comprovação de pagamento da GRU' },
  { value: 13, label: '13 - Pagamento da GRU aprovado' },
  { value: 14, label: '14 - Pagamento da GRU reprovado' },
  { value: 15, label: '15 - Defesa extraordinária' },
  { value: 16, label: '16 - Contestação extraordinária' },
];

export const tipoSituacaoGRUControlePagamento = [
  { value: 1, label: 'Em processamento' },
  { value: 2, label: 'Pago' },
  { value: 3, label: 'Não pago' },
];

export const getObject = (lista, value) => {
  const objeto = lista.filter(obj => (
    obj.value === value
  ));
  return objeto[0];
};

export const getObjectByIndex = (lista, value) => {
  const objeto = lista.filter(obj => (obj.index === value));
  return objeto[0];
};

export const tipoCtc = [
  { value: 1, label: 'Normal' },
  { value: 2, label: 'Judicial' },
  { value: 3, label: 'Recursal' },
];

export const tipoAfastamento = [
  { value: 1, label: 'Falta' },
  { value: 2, label: 'Licença' },
  { value: 3, label: 'Licença sem contribuição' },
  { value: 4, label: 'Suspensão' },
  { value: 5, label: 'Disponibilidade' },
  { value: 6, label: 'Outros' },
];

export const tipoTempoEspecial = [
  { value: 1, label: 'Segurado com deficiência grave' },
  { value: 2, label: 'Segurado com deficiência moderada' },
  { value: 3, label: 'Segurado com deficiência leve' },
  { value: 4, label: 'Policial, agente penitenciário ou agente socioeducativo' },
  { value: 5, label: 'Atividade especial 25 anos' },
  { value: 6, label: 'Atividade especial 20 anos' },
  { value: 7, label: 'Atividade especial 15 anos' },
  { value: 8, label: 'Professor do ensino infantil, fundamental e médio' },
];

export const ufs = [
  { value: 'AC', label: 'ACRE' },
  { value: 'AL', label: 'ALAGOAS' },
  { value: 'AP', label: 'AMAPA' },
  { value: 'AM', label: 'AMAZONAS' },
  { value: 'BA', label: 'BAHIA' },
  { value: 'CE', label: 'CEARA' },
  { value: 'DF', label: 'DISTRITO FEDERAL' },
  { value: 'ES', label: 'ESPIRITO SANTO' },
  { value: 'GO', label: 'GOIAS' },
  { value: 'MA', label: 'MARANHAO' },
  { value: 'MT', label: 'MATO GROSSO' },
  { value: 'MS', label: 'MATO GROSSO DO SUL' },
  { value: 'MG', label: 'MINAS GERAIS' },
  { value: 'PA', label: 'PARA' },
  { value: 'PB', label: 'PARAIBA' },
  { value: 'PR', label: 'PARANA' },
  { value: 'PE', label: 'PERNAMBUCO' },
  { value: 'PI', label: 'PIAUI' },
  { value: 'RJ', label: 'RIO DE JANEIRO (ESTADO)' },
  { value: 'RN', label: 'RIO GRANDE DO NORTE' },
  { value: 'RS', label: 'RIO GRANDE DO SUL' },
  { value: 'RO', label: 'RONDONIA' },
  { value: 'RR', label: 'RORAIMA' },
  { value: 'SC', label: 'SANTA CATARINA' },
  { value: 'SP', label: 'SAO PAULO (ESTADO)' },
  { value: 'SE', label: 'SERGIPE' },
  { value: 'TO', label: 'TOCANTINS' },
];

export const tiposProRataInicial = [
  { value: 1, label: 'RMI do Instituidor' },
  { value: 2, label: 'RMI Simulada' },
  { value: 3, label: 'Salário Minimo' },
  { value: 4, label: 'Media de Benefícios RGPS' },
];

export const situacaoCTC = [
  { value: 1, label: 'Ativa / Rascunho' },
  { value: 0, label: 'Inativa' },
];

export const meses = [
  // { value: 0, label: 'Jan', labelCompleto: 'Janeiro' },
  // { value: 1, label: 'Fev', labelCompleto: 'Fevereiro' },
  // { value: 2, label: 'Mar', labelCompleto: 'Março' },
  // { value: 3, label: 'Abr', labelCompleto: 'Abril' },
  // { value: 4, label: 'Mai', labelCompleto: 'Maio' },
  // { value: 5, label: 'Jun', labelCompleto: 'Junho' },
  // { value: 6, label: 'Jul', labelCompleto: 'Julho' },
  // { value: 7, label: 'Ago', labelCompleto: 'Agosto' },
  // { value: 8, label: 'Set', labelCompleto: 'Setembro' },
  // { value: 9, label: 'Out', labelCompleto: 'Outubro' },
  // { value: 10, label: 'Nov', labelCompleto: 'Novembro' },
  // { value: 11, label: 'Dez', labelCompleto: 'Dezembro' },
  // { value: 12, label: '13º', labelCompleto: 'Décimo terceiro salário' },

  // { value: 1, label: 'Jan', labelCompleto: 'Janeiro' },
  // { value: 2, label: 'Fev', labelCompleto: 'Fevereiro' },
  // { value: 3, label: 'Mar', labelCompleto: 'Março' },
  // { value: 4, label: 'Abr', labelCompleto: 'Abril' },
  // { value: 5, label: 'Mai', labelCompleto: 'Maio' },
  // { value: 6, label: 'Jun', labelCompleto: 'Junho' },
  // { value: 7, label: 'Jul', labelCompleto: 'Julho' },
  // { value: 8, label: 'Ago', labelCompleto: 'Agosto' },
  // { value: 9, label: 'Set', labelCompleto: 'Setembro' },
  // { value: 10, label: 'Out', labelCompleto: 'Outubro' },
  // { value: 11, label: 'Nov', labelCompleto: 'Novembro' },
  // { value: 12, label: 'Dez', labelCompleto: 'Dezembro' },
  // { value: 13, label: '13º', labelCompleto: 'Décimo terceiro salário' },

  {
    index: 0, value: 1, label: 'Jan', labelCompleto: 'Janeiro',
  },
  {
    index: 1, value: 2, label: 'Fev', labelCompleto: 'Fevereiro',
  },
  {
    index: 2, value: 3, label: 'Mar', labelCompleto: 'Março',
  },
  {
    index: 3, value: 4, label: 'Abr', labelCompleto: 'Abril',
  },
  {
    index: 4, value: 5, label: 'Mai', labelCompleto: 'Maio',
  },
  {
    index: 5, value: 6, label: 'Jun', labelCompleto: 'Junho',
  },
  {
    index: 6, value: 7, label: 'Jul', labelCompleto: 'Julho',
  },
  {
    index: 7, value: 8, label: 'Ago', labelCompleto: 'Agosto',
  },
  {
    index: 8, value: 9, label: 'Set', labelCompleto: 'Setembro',
  },
  {
    index: 9, value: 10, label: 'Out', labelCompleto: 'Outubro',
  },
  {
    index: 10, value: 11, label: 'Nov', labelCompleto: 'Novembro',
  },
  {
    index: 11, value: 12, label: 'Dez', labelCompleto: 'Dezembro',
  },
  {
    index: 12, value: 13, label: '13º', labelCompleto: 'Décimo terceiro salário',
  },
];

export const moedas = [
  { value: 1, label: 'RS$', descricao: 'Mil Réis' },
  { value: 2, label: 'Cr$', descricao: 'Cruzeiro' },
  { value: 3, label: 'NCr$', descricao: 'Cruzeiro Novo' },
  { value: 4, label: 'Cr$', descricao: 'Cruzeiro' },
  { value: 5, label: 'Cz$', descricao: 'Cruzado' },
  { value: 6, label: 'NCz$', descricao: 'Cruzado Novo' },
  { value: 7, label: 'Cr$', descricao: 'Cruzeiro' },
  { value: 8, label: 'CR$', descricao: 'Cruzeiro Real' },
  { value: 9, label: 'R$', descricao: 'Real' },
];

export const periodosMoedasBrasileiras = [
  // {
  //   value: 1, sigla: 'RS$', descricao: 'Mil Réis', dataInicio: '07/09/1822', dataFim: '31/10/1942',
  // },
  // {
  //   codigo: 2, sigla: 'Cr$', descricao: 'Cruzeiro', dataInicio: '01/11/1942', dataFim: '12/02/1967',
  // },
  // {
  //   codigo: 3, sigla: 'NCr$', descricao: 'Cruzeiro Novo', dataInicio: '13/02/1967', dataFim: '14/05/1970',
  // },
  // {
  //   codigo: 4, sigla: 'Cr$', descricao: 'Cruzeiro', dataInicio: '15/05/1970', dataFim: '27/02/1986',
  // },
  // {
  //   codigo: 5, sigla: 'Cz$', descricao: 'Cruzado', dataInicio: '28/02/1986', dataFim: '15/01/1989',
  // },
  // {
  //   codigo: 6, sigla: 'NCz$', descricao: 'Cruzado Novo', dataInicio: '16/01/1989', dataFim: '15/03/1990',
  // },
  // {
  //   codigo: 7, sigla: 'Cr$', descricao: 'Cruzeiro', dataInicio: '16/03/1990', dataFim: '31/07/1993',
  // },
  // {
  //   codigo: 8, sigla: 'CR$', descricao: 'Cruzeiro Real', dataInicio: '01/08/1993', dataFim: '30/06/1994',
  // },
  {
    codigo: 9, sigla: 'R$', descricao: 'Real', dataInicio: '01/07/1994', dataFim: null,
  },
];

export const anosPorAba = [
  { value: 6, label: '6' },
  { value: 12, label: '12' },
  { value: 18, label: '18' },
];

export const tiposSegregacoesDeMassa = [
  { value: 1, label: 'Fundo Financeiro (Repartição)' },
  { value: 2, label: 'Fundo Previdenciário (Capitalização)' },
];

export const estadoConflito = [
  { value: 0, label: 'Não Resolvido' },
  { value: 1, label: 'Resolvido, pois um dos requerimentos foi para um estado inválido (indeferido, rejeitado, criado rejeitado, indeferido ratificado)' },
  { value: 2, label: 'Resolvido, pois um dos requerimentos teve os períodos ajustados pelo Solicitante eliminando concomitâncias' },
  { value: 3, label: 'Resolvido, pois ambos requerimentos tiveram seus períodos aprovados pelo Regime de Origem' },
  { value: 4, label: 'Resolvido, pois houve alteração do destinatário do requerimento' },
  { value: 5, label: 'Resolvido, pois um dos requerimentos teve alteração de CPF pela Qualificação' },
  { value: 6, label: 'Resolvido, pois houve alteração da matrícula do requerimento' },
];

export const estadoConflitoSimplificado = [
  { value: 0, label: 'Não Resolvido' },
  { value: 1, label: 'Resolvido' },
  { value: 2, label: 'Resolvido' },
  { value: 3, label: 'Resolvido' },
  { value: 4, label: 'Resolvido' },
  { value: 5, label: 'Resolvido' },
  { value: 6, label: 'Resolvido' },
];



// WEBPACK FOOTER //
// ./src/utils/listsSelect.js